"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Instagram = _interopRequireDefault(require("mdi-material-ui/Instagram"));
var _Soundcloud = _interopRequireDefault(require("mdi-material-ui/Soundcloud"));
var _Twitter = _interopRequireDefault(require("mdi-material-ui/Twitter"));
var _Youtube = _interopRequireDefault(require("mdi-material-ui/Youtube"));
var _Facebook = _interopRequireDefault(require("mdi-material-ui/Facebook"));
var _Apple = _interopRequireDefault(require("mdi-material-ui/Apple"));
var _Spotify = _interopRequireDefault(require("mdi-material-ui/Spotify"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SocialMediaIconLink = props => {
  var classes = (0, _styles.default)(props);
  var {
    type,
    variant,
    theme
  } = props;
  var {
    href
  } = props;
  href = '//' + href.replace('https://', '').replace('www.', '');
  var getClassFromVariant = () => {
    var classNames = [classes["".concat(theme, "IconColor")]];
    if (variant === 'large') classNames.push(classes.large);else if (variant === 'medium') classNames.push(classes.medium);else if (variant === 'small') classNames.push(classes.small);
    return (0, _clsx.default)(...classNames);
  };
  var getIcon = () => {
    var className = getClassFromVariant();
    switch (type) {
      case 'facebook':
        return /*#__PURE__*/_react.default.createElement(_Facebook.default, {
          className: className
        });
      case 'instagram':
        return /*#__PURE__*/_react.default.createElement(_Instagram.default, {
          className: className
        });
      case 'soundcloud':
        return /*#__PURE__*/_react.default.createElement(_Soundcloud.default, {
          className: className
        });
      case 'twitter':
        return /*#__PURE__*/_react.default.createElement(_Twitter.default, {
          className: className
        });
      case 'youtube':
        return /*#__PURE__*/_react.default.createElement(_Youtube.default, {
          className: className
        });
      case 'appleMusic':
        return /*#__PURE__*/_react.default.createElement(_Apple.default, {
          className: className
        });
      case 'spotify':
        return /*#__PURE__*/_react.default.createElement(_Spotify.default, {
          className: className
        });
      default:
        console.error("Unrecognized Social Media Type: ".concat(type));
        return null;
    }
  };
  return /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    target: '_blank'
  }, getIcon());
};
SocialMediaIconLink.defaultProps = {
  theme: 'dark'
};
var _default = exports.default = SocialMediaIconLink;